import { useMemo } from "react";
import { EyeIcon, DeleteIcon } from "../assets/icons";
import isColorDark from "../helpers/utils/isColorDark";
import { getRandomColor } from "../helpers/utils/utils";

const useTransformNewData = (
  users,
  onView,
  onDelete,
  userCanDelete = false
) => {
  const transformedData = useMemo(() => {
    return users.map((user, index) => ({
      id: { value: (index + 1).toString().padStart(3, "0"), component: "" },
      userName: { value: user.username, component: "" },
      organization: { value: user.organization?.name || "NA", component: "" },

      roles: {
        value:
          user?.roles
            ?.map((role) => `${role.name} (${role.authorities?.join(", ")})`)
            .join(", ") || "No value",
        component: (
          <div className="group-wrapper">
            {user?.roles?.length ? (
              user.roles.map((role) => (
                <p
                  key={role.name}
                  className="badge"
                  style={{
                    backgroundColor: role.color || getRandomColor(role.name),
                    color: isColorDark(role.color || getRandomColor(role.name))
                      ? "#fff"
                      : "#000",
                  }}
                >
                  {role.name || "No value"}
                </p>
              ))
            ) : (
              <p>{user?.roles?.[0]?.name || "No value"}</p>
            )}
          </div>
        ),
      },

      groups: {
        value:
          user?.groups?.map((group) => group.name).join(", ") || "No value",
        component: (
          <div className="group-wrapper">
            {user?.groups?.length ? (
              user.groups.map((group) => (
                <p
                  key={group.name}
                  className={`${group.name ? "badge" : ""}`}
                  style={{
                    backgroundColor: group.color ? group.color : "#ccc",
                    color: isColorDark(group.color) ? "#fff" : "#000",
                  }}
                >
                  {group.name || "No value"}
                </p>
              ))
            ) : (
              <p
                className={`${user?.groups?.[0]?.name ? "badge" : ""}`}
                style={{ backgroundColor: user?.groups?.[0]?.color }}
              >
                {user?.groups?.[0]?.name || "No value"}
              </p>
            )}
          </div>
        ),
      },

      actions: {
        value: [],
        component: (
          <div className="actions-wrapper">
            <div
              className="action-icon"
              style={{ cursor: "pointer" }}
              onClick={() => onView(user)}
            >
              <EyeIcon fillColor="var(--archeo-color)" />
            </div>
            {userCanDelete && (
              <div
                className="action-icon"
                style={{ cursor: "pointer" }}
                onClick={() => onDelete(user)}
              >
                <DeleteIcon fillColor="var(--archeo-color)" />
              </div>
            )}
          </div>
        ),
      },
    }));
  }, [
    users,
    onView,
    onDelete,
    userCanDelete,
  ]);

  return transformedData;
};

export default useTransformNewData;
